export const environment = {
  enableSentry: true
}